// extracted by mini-css-extract-plugin
module.exports = {"main_container":"PageNotFound_main_container__3VE-F","pnf":"PageNotFound_pnf__WHfdY","toHomeButton":"PageNotFound_toHomeButton__3HNu2","button404":"PageNotFound_button404__1vEk7"};